module.exports = __webpack_public_path__ + "static/media/thesis_pdf2.590198c3.jpg";